import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductDocument.Replace.IRequest;
type Response = Api.Core.ProductDocument.Replace.IResponse;
type Headers = Api.Core.ProductDocument.Replace.IHeaders;
const url = '/api/ProductManagement/ProductDocument/:productId/ReplaceFile/:documentId';
export default async function productDocumentReplaceApi(body: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Pick<Request, 'formFile'>, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, { productId: body.productId, documentId: body.documentId }),
    body: { formFile: body.formFile },
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
